<template>
  <div v-if="$store.state.webLoaded" class="jumbotron no_space dmbs-container">

     <Body />
 
  </div>
</template>

<script>
import Body from "@/components/plantilla/Slider.vue";

export default {
  name: "home",
  components: {
    Body,
  },
};
</script>
